import React from 'react';
import {Slide, ToastContainer} from 'react-toastify';
import {Outlet} from 'react-router-dom';
import login from '../../assets/images/Samart-Splash.webp';

export const LoginContainer = () => (
    <div>
        <div className="flex flex-row w-screen">
            <div className={'w-full'}>
                <Outlet/>
            </div>
        </div>

        <ToastContainer
            position="top-center"
            hideProgressBar
            autoClose={5000}
            transition={Slide}
            closeOnClick
        />
    </div>
);
